import { queryClient } from '@/plugins/vue-query'

/**
 * Cached "every X for a picker" fetch for a workspace-scoped list, shared by the
 * Pinia list actions. A real paginated call (`params.page` set) always hits the
 * network and is never cached. Otherwise the result lives in the query cache
 * keyed by list + workspace + params, concurrent callers share one request, and
 * it stays fresh until a mutation calls `invalidateList(name)` (or `refresh`).
 */
export function fetchCachedList(name, workspaceId, params, fetcher, refresh = false) {
  if (params && params.page != null) return fetcher()
  return queryClient.fetchQuery({
    queryKey: [name, 'all', workspaceId, params ?? {}],
    queryFn: fetcher,
    staleTime: refresh ? 0 : Infinity,
  })
}

/** Marks every cached query of a list stale: the picker cache (`[name, 'all', …]`) and list-page queries (`[name, 'list', …]`). */
export function invalidateList(name) {
  return queryClient.invalidateQueries({ queryKey: [name] })
}
